import { render, staticRenderFns } from "./SchoolTest.vue?vue&type=template&id=acbdd338&scoped=true&lang=pug&"
import script from "./SchoolTest.vue?vue&type=script&lang=ts&"
export * from "./SchoolTest.vue?vue&type=script&lang=ts&"
import style0 from "./SchoolTest.vue?vue&type=style&index=0&id=acbdd338&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acbdd338",
  null
  
)

export default component.exports